import React from 'react';
import TitleMasterPage from './TitleMasterPage';
import {
  createMasterPlantRequiringIsolation,
  deleteMasterPlantRequiringIsolation,
  getMasterPlantRequiringIsolations,
  updateMasterPlantRequiringIsolation,
} from '../../../services/masterPlantRequiringIsolationService';

const PlantRequiringIsolations: React.FC = () => (
  <TitleMasterPage
    heading="Plant Requiring Isolations"
    singular="Plant Requiring Isolation"
    loadItems={getMasterPlantRequiringIsolations}
    createItem={createMasterPlantRequiringIsolation}
    updateItem={updateMasterPlantRequiringIsolation}
    deleteItem={deleteMasterPlantRequiringIsolation}
  />
);

export default PlantRequiringIsolations;
